export default __webpack_public_path__ + "static/media/live-casino.44291294.svg";